// The official store badges (artwork already shipped for the landing page).
export const APP_STORE_URL = 'https://apps.apple.com/us/app/voto/id580618658';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.votomoto.app';

export default function StoreBadges({ className = '', size = 'h-11' }) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center rounded-lg transition hover:opacity-90"
        aria-label="Download Voto on the App Store"
      >
        <img src="/voto/landy/app-store-badge.svg" alt="Download on the App Store" className={`${size} w-auto`} />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center rounded-lg transition hover:opacity-90"
        aria-label="Get Voto on Google Play"
      >
        <img src="/voto/landy/google-play-badge.svg" alt="Get it on Google Play" className={`${size} w-auto`} />
      </a>
    </div>
  );
}
